import { render } from "./BillingView.vue?vue&type=template&id=88b2b124&scoped=true&ts=true"
import script from "./BillingView.vue?vue&type=script&lang=ts"
export * from "./BillingView.vue?vue&type=script&lang=ts"

import "./BillingView.vue?vue&type=style&index=0&id=88b2b124&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b2b124"]])

export default __exports__